import React, { useCallback } from "react";
import { connectSearchBox } from "react-instantsearch-dom";
import Input from "~components/atoms/input/input";

export default connectSearchBox(
  ({ refine, currentRefinement, onFocus, ...rest }) => {
    const { hasBorder, placeholder, trailingIcon, leadingIcon, size } = rest;

    const handleRefine = useCallback(
      (value) => {
        return refine(value);
      },
      [refine]
    );

    return (
      <Input
        hasBorder={hasBorder}
        value={currentRefinement}
        onFocus={onFocus}
        placeholder={placeholder}
        onChange={handleRefine}
        trailingIcon={trailingIcon}
        leadingIcon={leadingIcon}
        type="search"
        allowClear
        size={size}
      />
    );
  }
);
